(function () {
    'use strict';

    angular
        .module('questionnaireTemplatesEditModule')
        .controller('ODDQuestionnaireTemplatesListController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'businessUnit', 'questionnaireTemplates'];

    function Controller($scope, $state, topBarService, businessUnit, questionnaireTemplates) {

        topBarService.setTitleAndIcon('Operational Due Diligence | ' + businessUnit.TitleEN, 'icon icon-clipboard');

        $scope.questionnaireTemplates = questionnaireTemplates;

        // Add Questionnaire
        $scope.addQuestionnaire = function () {
            $state.go('odd.questionnaireTemplatesEdit.addQuestionnaire');
        };

        // Go To Questionnaire Templates
        $scope.goToQuestionnaireTemplate = function (qTemplate) {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire', { ODDQuestionnaireID: qTemplate.ODDQuestionnaireID });
        };
    }
})();